import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { addFuelingServiceImage } from '../../api/fueling-service.ts';
import { AddFuelingServiceImageRequest } from '../../api/requests/fueling-service-request.ts';

export default function useAddFuelingServiceImage(): UseMutationResult<
  Awaited<ReturnType<typeof addFuelingServiceImage>>,
  Error,
  AddFuelingServiceImageRequest
> {
  return useMutation({
    mutationFn: addFuelingServiceImage,
  });
}
